export default __webpack_public_path__ + "static/media/June_04.199051b4.png";